// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__qyJyP","productName":"Table_productName__2JgPf"};